import GiftKlydoPlayer from '../../components/KlydoPlayer/GiftKlydoPlayer';
import { GiftKlydo, KlydoGiftProps } from '../../api/gift';

export type GiftViewProps = {
  klydo: GiftKlydo;
  gift: Partial<KlydoGiftProps>;
  isToggled?: boolean;
  scale?: number;
};

const GiftView = ({ klydo, gift, isToggled = false, scale }: GiftViewProps) => {
  if (!klydo) return null;

  return (
    <GiftKlydoPlayer
      klydo={klydo}
      pendulumLogo={gift?.pendulumLogoUrl}
      pendulumLogoType={gift?.pendulumLogoType}
      senderName={gift?.senderName}
      senderImageUrl={gift?.senderImageUrl}
      greetingContent={gift?.greetingContent}
      date={gift?.date}
      isToggled={isToggled}
      scale={scale}
    />
  );
};

export default GiftView;
